<!-- <ng-container *ngFor="let data_ of data"> -->

  <div class="adc-rdo" *ngIf="data.type == 'default'">
    <ng-container *ngFor="let items of data.items">
      <input type="radio" name="{{items.itemName}}" id="{{items.itemId}}" [checked]="items.checked" [disabled]="items.disabled" (change)="onRadioChange(items.itemId)">
      <label for="{{items.itemId}}">
          {{items.itemLabel}}
      </label>
    </ng-container>
  </div>

  <form class="adc-rdogrp-hr" *ngIf="data.type == 'horizontal'">
    <div class="adc-rdo" *ngFor="let i of data.items">
      <input type="radio" name="{{i.itemName}}" id="{{i.itemId}}" [checked]="i.checked" [disabled]="i.disabled" (change)="onRadioChange(i.itemId)">
      <label for="{{i.itemId}}">
        {{i.itemLabel}}
      </label>
    </div>
  </form>

  <form class="adc-rdogrp-vr" *ngIf="data.type == 'vertical'">
    <div class="adc-rdo" *ngFor="let i of data.items">
      <input type="radio" name="{{i.itemName}}" id="{{i.itemId}}" [checked]="i.checked" [disabled]="i.disabled" (change)="onRadioChange(i.itemId)">
      <label for="{{i.itemId}}">
        {{i.itemLabel}}
      </label>
    </div>
  </form>

<!-- </ng-container> -->
